import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedBeetweenAppsModule } from '@shared/shared-beetween-apps.module';
import { LoginAppComponent } from './login-app.component';
import { LoginAppRouterModule } from './login-app.router';
import { ErrorSSOPageComponent } from './module/error-sso/error-sso.component';
import { LoginModule } from './module/login.module';


@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        LoginAppRouterModule,
        LoginModule,
        SharedBeetweenAppsModule.forRoot(),
    ],
    declarations: [LoginAppComponent, ErrorSSOPageComponent],
    bootstrap: [LoginAppComponent],
    providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class LoginAppModule { }
